const moveFlipbookText = () => {
    // on flipbook pages, places elements above the flipbook container
    // h1 (item contents's title)
    // h1 (if h1 is present in WYSIWYG)
    // first or second p tag (if p tag has text and is present in WYSIWYG)

    const entryWrapper = document.querySelector('.entry-wrapper');
    const gatedCTA = document.querySelector('div.block-cta');
    if (entryWrapper && gatedCTA) {
        const firstParagraph = entryWrapper.querySelector('h1');
        const singleEmbed = document.querySelector('.single-embed-wrapper');

        // moves first h1 above the flipbook container (content title)
        if (firstParagraph && singleEmbed) {
            singleEmbed.insertAdjacentElement('beforebegin', firstParagraph);
            firstParagraph.style.marginBottom = '20px';
        }
    }
    // Uberflip GWL OB-7374 start here
    const singleWrapper = document.querySelector('.single-embed-wrapper');
    // const levelWrapper = document.querySelector('.level-three p:nth-child(1)');
    const firstTag = document.querySelector('.entry-wrapper .entry p');
    const firstHead = document.querySelector('.entry-wrapper h1');

    // move first h1 inside of the item-level content WYSIWYG, above the flipbook
    if (singleWrapper && firstHead) {
        singleWrapper.insertAdjacentElement('beforebegin', firstHead);
    }
    if (!firstTag) {
        return;
    }

    if (!singleWrapper) {
        return;
    }

    // if (levelWrapper && firstHead) {
    //     levelWrapper.insertAdjacentElement('beforebegin', firstHead);
    // }
    
    // grabs first paragraph tag in WYSIWYG and puts it above the flipbook
    const len = firstTag.innerHTML;
    // if first tag has no text (empty <p> tag, grab the second)
    if (len.length < 1) {
        const secondTag = document.querySelector('.entry-wrapper .entry').childNodes[2];
        if (singleWrapper && secondTag) {
            singleWrapper.insertAdjacentElement('beforebegin', secondTag);
            document.querySelector("body").classList.add("move-tag");
        }
    } else {
        singleWrapper.insertAdjacentElement('beforebegin', firstTag);
        document.querySelector("body").classList.add("move-tag");
    }

    // Uberflip GWL OB-7374 end here
};

module.exports = { moveFlipbookText };


// WEBPACK FOOTER //
// ./scriptPartials/moveFlipbookText.js